import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UsuarioEmpresaDetalharRoutingModule } from './usuario-empresa-detalhar-routing.module';
import { UsuarioEmpresaDetalharComponent } from './usuario-empresa-detalhar.component';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { FormatPipeModule } from 'src/app/admihair/format-pipe/format-pipe.module';
import { FormsModule } from '@angular/forms';
import { MessagesModule } from 'primeng/messages';
import { TreeTableModule } from 'primeng/treetable';
import { ProgressSpinnerModule } from 'primeng/progressspinner';


@NgModule({
  declarations: [
    UsuarioEmpresaDetalharComponent
  ],
  imports: [
    CommonModule,
    UsuarioEmpresaDetalharRoutingModule,
    FormsModule,
    ButtonModule, 
    DividerModule,
    MessagesModule,
    FormatPipeModule,
    TreeTableModule,
    ProgressSpinnerModule,
  ]
})
export class UsuarioEmpresaDetalharModule { }
